module.exports = __webpack_public_path__ + "static/media/cq_file_exel_b.38930577.svg";